import React, {useEffect, useState} from 'react';
import PropTypes from 'prop-types';
import { useDispatch } from 'react-redux';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { ModalHeader, ModalBody, ModalFooter } from 'reactstrap';
import { Button } from 'antd';
import { StyledModal, StyledAddActionButton } from './styled';
import { getLrProjectsError, StyledModalHeaderIcon } from '../../../shared';
import { handleFetchError, getAddButtonEnabled } from '../../../helpers';
import { projectActions, projectEntryActions } from '../../../store';
import { Dropdown } from '../../../components/Dropdown';
import moment from 'moment';

const AddEngineeringProject = ({ firstDayOfTheWeek, onAddProject, localEntries }) => {
  const dispatch = useDispatch();
  
  const [isOpen, setOpen] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [vpinProjects, setVpinProjects] = useState([]);
  const [project, setProject] = useState({});
  const [isAddButtonAvailable, setIsAddButtonAvailable] = useState(false);

  const onClose = () => {
    setOpen(false)
    setProject({})
    setIsLoading(false)
    setVpinProjects([])
  }

  const onProjectChange = (data) => {
    setProject(data)
  }

  const onSubmit = async () => {
    const date = moment(firstDayOfTheWeek).format('YYYY-MM-DD');

    try {
      const editableDates = await dispatch(projectEntryActions.getEditableDatesByProjectByWeek(project.projectNumber, date));

      onAddProject(project, editableDates);
      onClose();
    } catch (e) {
      handleFetchError(e, getLrProjectsError);
    }
  }

  useEffect(() => {
    setIsAddButtonAvailable(getAddButtonEnabled(firstDayOfTheWeek));
    if (!isOpen) 
      return

    setIsLoading(true);

    const getVpinProjectData = async () => {
      try {
        const projectData = await dispatch(projectActions.getAllVpinProjects(firstDayOfTheWeek));
        const filteredData = projectData.data.filter(p => p.projectNumber != localEntries.find(e => e.projectNumber == p.projectNumber)?.projectNumber);
        setVpinProjects(filteredData);
      } catch (e) {
        handleFetchError(e, getLrProjectsError);
      }

      setIsLoading(false);
    }
    getVpinProjectData();
  }, [isOpen, localEntries, firstDayOfTheWeek])

  return (
    <>
      <StyledAddActionButton disabled={!isAddButtonAvailable} onClick={() => setOpen(true)} light>
        <FontAwesomeIcon icon="plus" /> Add Project
      </StyledAddActionButton>
      <StyledModal size="md" centered isOpen={isOpen}>
        <ModalHeader toggle={onClose} disabled={isLoading}>
          <StyledModalHeaderIcon icon="plus" />Add Project
        </ModalHeader>
        <ModalBody>
          <Dropdown 
            loading={isLoading}
            options={vpinProjects}
            value={project}
            placeholder={'Search...'}
            onChange={onProjectChange}
            windowMode={true}
            dataTestId="project"
            getOptionValue={option => option.projectNumber}
            getOptionLabel={option => option.projectNumber}
          />
        </ModalBody>
        <ModalFooter>
          <Button primary outline onClick={onClose} disabled={isLoading}>
                    Cancel
          </Button>
          <Button
            primary
            onClick={() => onSubmit()}
            loading={isLoading}
            disabled={project == {}}
          >
                    Add Project
          </Button>
        </ModalFooter>
      </StyledModal>
    </>
  )
}


AddEngineeringProject.propTypes = {
  firstDayOfTheWeek: PropTypes.object,
  onAddProject: PropTypes.func,
  localEntries: PropTypes.arrayOf(PropTypes.object)
}

export default AddEngineeringProject;